<div class="flex flex-column w-full h-full gap-3 p-4">
  <div class="block align-items-center justify-content-between px-2 sm:flex">
    <p class="font-semibold text-xl" style="color: #163960">
      <i class="pi pi-angle-right" style="color: #163960; font-size: 1rem"></i>
      Reclamos finalizados
    </p>
  </div>
  <div class="p-2">
    <p-tabView
      [(activeIndex)]="currentTabIndex"
      (onChange)="onTabChange($event)"
    >
      <p-tabPanel header="Reclamos individuales"></p-tabPanel>
      <p-tabPanel header="Reclamos colectivos"></p-tabPanel>
      <p-tabPanel header="Reclamos plurindividuales"></p-tabPanel>
    </p-tabView>
    <app-claims-tables
      [haveResults]="haveResults"
      [filterKey]="filterKey"
      [userClaims]="userClaims"
      [skeleton]="skeleton"
      [pagination]="pagination"
      [isPluri]="currentTabIndex === 2"
      (filters)="onFiltersApplied($event)"
      (cancel)="onFilterCancel()"
    ></app-claims-tables>
  </div>
</div>
